export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/blog.0c682a6.svg";